import React, { useEffect } from 'react';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import { pageView } from '../../Utilities/GoogleAnalytics';
import ReviewSection from '../../Components/ReviewSection';

export default function Reviews() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
    window.scroll(0, 0);
  }, []);

  const TitleSection = () => {
    return (
      <>
        <div className="flex flex-col-reverse items-center h-auto pt-20 bg-altBack lg:flex-row lg:pt-32">
          <div className="w-full p-12 text-center lg:p-0">
            <h1 className="text-3xl font-bold text-brandcolor font-brand lg:text-5xl">Reviews</h1>
            <p className="w-full text-gray-700 lg:w-2/3 lg:m-auto text-md lg:text-xl font-brand"> Read what people are saying</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="min-h-screen bg-altBack">
      <TopBar />
      <TitleSection />
      <ReviewSection />
      <Footer />
    </div>
  );
}
